import { generateCsvTemplate } from "./generateCsvTemplate";

export default generateCsvTemplate;
